/**
 * Model for dynamic actions
 */
export abstract class ActionButton{
    loading: boolean = false;
    errorMessage: string = '';
    successMessage: string = '';
    public abstract invoke(payload: any): void;
}